<div class="modal">
  @if (showClose()) {
    <div class="flex justify-end items-center">
      <lib-btn-close [buttonType]="'modal-exit'"></lib-btn-close>
    </div>
  }

  <div class="modal__content">
    <div>
      <div class="text-center">
        <h2 class="modal__content-title">
          {{ title() }}
        </h2>
        
        <h2 class="app modal__content-subtitle">
          {{ subtitle() }}
        </h2>
      </div>
      <div class="modal__content-body">
        <ng-content></ng-content>
      </div>
    </div>
    <div class="modal__content-buttons text-center">
      <ng-content select="[btnPrimary]"></ng-content>
      <ng-content select="[btnSecondary]"></ng-content>
    </div>
  </div>
</div>
